/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Noattemptsyet2Inputs */

const zh_learn_noattemptsyet2 = /** @type {(inputs: Learn_Noattemptsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有作答记录`)
};

const en_learn_noattemptsyet2 = /** @type {(inputs: Learn_Noattemptsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No attempts yet`)
};

const es_learn_noattemptsyet2 = /** @type {(inputs: Learn_Noattemptsyet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay intentos`)
};

/**
* | output |
* | --- |
* | "No attempts yet" |
*
* @param {Learn_Noattemptsyet2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_noattemptsyet2 = /** @type {((inputs?: Learn_Noattemptsyet2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Noattemptsyet2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_noattemptsyet2(inputs)
	if (locale === "en") return en_learn_noattemptsyet2(inputs)
	return es_learn_noattemptsyet2(inputs)
});
export { learn_noattemptsyet2 as "learn_noAttemptsYet" }